import React, {useEffect}from "react";

import WelcomeSection from "../../shared/components/WelcomeSection/WelcomeSection";
import MembershipTerms from '../components/MembershipTerms/MembershipTerms';

import termsOfServiceBannerImg from '../../utils/assets/termsOfService/terms-and-conditions.png';
import NavegationInfo from "../../shared/components/NavegationInfo/NavegationInfo";

const TermsOfService = props => {

    const bannerSectionInfo =
     {
        cardTitle: "Terms and conditions for the use of this service",
        cardBodyText: ``,
        cardButtonText: "Make a Call",
        lengendBackground: termsOfServiceBannerImg
     }
     useEffect(()=>{
        window.scrollTo(0, 0);
    }, [])

    return (
        <React.Fragment>
           <WelcomeSection props={bannerSectionInfo}/>
           <NavegationInfo page="Terms of service"/>
            <MembershipTerms/>
        </React.Fragment>
    );
};

export default TermsOfService;